import { apiClient } from "./client";

const API_URL = import.meta.env.VITE_BACKEND_URL;

const auth = {
  login: (email, password) =>
    apiClient("/auth/login", {
      method: "POST",
      body: { email, password },
      requiresAuth: false,
    }),

  register: ({ name, email, password, token }) =>
    apiClient(`/auth/register?token=${token}`, {
      method: "POST",
      body: { name, email, password },
      requiresAuth: false,
    }),

  logout: () =>
    apiClient("/auth/logout", {
      method: "GET",
    }),

  validateSession: () =>
    apiClient("/auth/validate-session", {
      method: "GET",
      requiresAuth: false,
    }),

  refresh: async () => {
    try {
      const response = await fetch(`${API_URL}/auth/refresh-tokens`, {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        const errorResp = await response.json();
        return { error: errorResp.error || { message: "Failed to refresh tokens" } };
      }

      return await response.json();
    } catch (error) {
      return { error: { message: error.message } };
    }
  },

  verifyInvitation: (token) =>
    apiClient(`/invitations/verify?token=${encodeURIComponent(token)}`, {
      method: "GET",
      requiresAuth: false,
    }),

  getProfile: () => apiClient("/auth/me", { method: "GET" }),

  changePassword: (passwordOld, passwordNew) =>
    apiClient("/auth/change-password", {
      method: "POST",
      body: { passwordOld, passwordNew },
      requiresAuth: true,
    }),
};

export async function requestPasswordReset(email) {
  return apiClient("/auth/forgot-password", {
    method: "POST",
    body: { email },
    requiresAuth: false,
  });
}

export async function verifyResetToken(token) {
  return apiClient(`/auth/verify-reset-token?token=${encodeURIComponent(token)}`, {
    method: "GET",
    requiresAuth: false,
  });
}

export async function resetPassword(token, password) {
  return apiClient("/auth/reset-password", {
    method: "POST",
    body: { token, password },
    requiresAuth: false,
  });
}

export default auth;
